import React from 'react'
// import './styles.css';
import Avatar from '@mui/material/Avatar'

// Default text if no return avatar
const GeneratedAvatar = ({
  text,
  width = 40,
  variant = 'circular',
  fontSize,
  borderColor = '#469cf86c',
  fontColor,
  hasborder = false,
  fontWeight,
  height = 40,
  borderWidth = '1px',
  src = '',
  alt,
  ...rest
}) => {
  const defaultText = 'M'

  const getStyles = () => {
    let componentStyle = {
      width,
      height,
      fontSize,
      fontWeight,
    }

    if (fontColor) {
      componentStyle = { ...componentStyle, color: fontColor }
    }

    if (borderWidth && borderColor && hasborder) {
      componentStyle = { ...componentStyle, border: `${borderWidth} solid ${borderColor}` }
    }

    if (variant === 'square' && hasborder) {
      componentStyle = { ...componentStyle, borderRadius: '4px' }
    }

    return componentStyle
  }
  
  return (
    <Avatar
      className="avatar-generated"
      sx={{ backgroundColor: "#469CF8" }}
      variant={variant}
      style={getStyles()}
      alt={alt}
      src={src}
      {...rest}
    >
      {(text || defaultText).charAt(0).toUpperCase()}
    </Avatar>
  )
}

export default GeneratedAvatar
